<template>
  <teleport to="body">
    <TsModal
      append-class="p-6 mx-4 max-w-lg relative"
      v-model:visible="savelistStore.remove_product_modal"
    >
      <template #modal-content>
        <div
          class="mx-auto bg-natural-soft-white rounded-full flex justify-center items-center w-[60px] h-[60px] mb-6"
        >
          <TsIcon
            class="text-danger"
            name="material-symbols:delete-outline"
            size="32"
          />
        </div>

        <TsIcon
          class="text-idle-black cursor-pointer absolute top-6 right-6"
          name="charm:cross"
          size="24"
          @click="savelistStore.remove_product_modal = false"
        />

        <TsTypography as="h2" variant="h1" align="center">
          {{ savelistStore.savelist_item_to_delete.name }}
        </TsTypography>

        <TsTypography append-class="mx-auto md:max-w-[90%]" align="center">
          {{useTranslation("Savelist-delete","Weet je zeker dat je dit product uit je kluslijst wilt verwijderen?")}}
        </TsTypography>

        <div class="flex gap-3 mt-8">
          <TsButton
            :label="useTranslation('cancel' , 'Annuleren')" 
            @click="savelistStore.remove_product_modal = false"
            block
            variant="secondary"
            outlined
          />
          <TsButton
            :label="useTranslation('Savelist-yesRemove' , 'Ja, verwijderen')"
            variant="danger"
            block
            @click="deleteItemFromSavelist()"
            data-testid="savelist-confirm-delete-btn"
          />
        </div>
      </template>
    </TsModal>
  </teleport>
</template>

<script setup lang="ts">
const savelistStore = useSavelistStore();

const deleteItemFromSavelist = async () => {
  try {
  await savelistStore.deleteItemFromSavelist(
    savelistStore.current_active_savelist.id,
    savelistStore.savelist_item_to_delete.product_code
  );
  } catch (error) {
   return error
  }
};
</script>
